module.exports = __webpack_public_path__ + "static/img/24.976d931.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/24.png
// module id = Bc44
// module chunks = 1